import { render, staticRenderFns } from "./Prestation.vue?vue&type=template&id=5470346c&"
import script from "./Prestation.vue?vue&type=script&lang=ts&"
export * from "./Prestation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports